import { Button, Col, Row } from 'components';
import { isBefore } from 'date-fns';
import { Api, theme } from 'lib';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DateTime, Round, Score, Status, TopSection } from './';

const Game = ({ data, closeModal }) => {
  const [round, setRound] = useState(null),
    [matchNumber, setMatchNumber] = useState(null),
    [score, setScore] = useState({ home: null, away: null }),
    [status, setStatus] = useState(null),
    [progress, setProgress] = useState(null),
    [gameStatus, setGameStatus] = useState(null),
    [date, setDate] = useState(null),
    dispatch = useDispatch(),
    // can update score only for in-play/past games
    canUpdateScore =
      data &&
      isBefore(new Date(data.date), new Date()) &&
      ['in-play', 'finished'].includes(status?.opt);

  async function handleSave() {
    if (canUpdateScore && (!score?.home?.length || !score?.away?.length)) {
      dispatch({
        type: 'HANDLE_RES',
        payload: { err: 'Score for both sides should be set' }
      });

      return;
    }

    let payload = {
      round: round,
      matchNumber: matchNumber,
      status: status?.opt,
      gameId: data._id,
      score,
      date,
      progress,
      gameStatus
    };

    const res = await Api.post('/games/update', payload, 'editGame');
    if (!res) return;

    dispatch({
      type: 'ADMIN_UPDATE_GAME',
      payload: { ...res, gameId: data._id }
    });

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: 'Game saved succesfully' }
    });
  }

  return (
    <Col ht="calc(100% - 55px)">
      <TopSection data={data} />

      <Col start wid="calc(100% - 48px)" pad="24px" between>
        <Col noFlex wid="100%">
          <Score data={data} score={score} setScore={setScore} canUpdateScore={canUpdateScore} />

          <Status
            data={data}
            status={status}
            setStatus={setStatus}
            progress={progress}
            setProgress={setProgress}
            gameStatus={gameStatus}
            setGameStatus={setGameStatus}
          />

          <Round data={data} round={round} setRound={setRound} matchNumber={matchNumber} setMatchNumber={setMatchNumber} />

          <DateTime date={date} setDate={setDate} data={data} />
        </Col>

        <Row marg="56px 0 0">
          <Button big text="Cancel" onClick={closeModal} marg="0 24px 0 0" bordered />

          <Button
            big
            onClick={handleSave}
            text="Edit game"
            bg={theme.SECONDARY}
            action="editGame"
          />
        </Row>
      </Col>
    </Col>
  );
};

export default Game;
